<template>
  <PopupChatAI />
  <router-view />
</template>

<style lang="scss">
#app {
    font-family: Meiryo, "Yu Gothic", Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    
}
 // height: 100%;

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

<script>
import PopupChatAI from './components/PopupChatAI.vue';

export default {
  components: { PopupChatAI }
};
</script>